import { defineStore } from 'pinia';
import { ref } from 'vue';
import usersAPI from '@/api/users';
import type { User } from '@/types/User';

export const useUsersStore = defineStore('users', () => {
  const users = ref<User[]>([]);
  const users_result = ref<User[]>([]);
  
  const fetchUsers = async (params: any): Promise<{ data: User[]; total: number }> => {
    try {
      
      const response = await usersAPI.getUsers(params);
      const data: User[] = response.data.data;
      const total = response.data.meta.total;
      users.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching user s:', error);
      throw error;
    }
  };

  const fetchUserById = async (id: number) => {
    try {
      const response = await usersAPI.getUserById(id);
      return response.data.data as User;
    } catch (error) {
      console.error(`Error fetching user  with ID ${id}:`, error);
    }
  };

  const createUser = async (userData: Partial<User>) => {
    try {
      const response = await usersAPI.createUser(userData);
      users.value.push(response.data.data as User);
      return response.data;
    } catch (error) {
      console.error('Error creating user :', error);
    }
  };

  const updateUser = async (id: number, userData: Partial<User>) => {
    try {
      const response = await usersAPI.updateUser(id, userData);
      const updated = response.data.data as User;
      const index = users.value.findIndex((c) => c.id === id);
      if (index !== -1) {
        users.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating user  with ID ${id}:`, error);
    }
  };

  const deleteUser = async (id: number) => {
    try {
      await usersAPI.deleteUser(id);
      users.value = users.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting user  with ID ${id}:`, error);
    }
  };

  const searchUsers = async (params: any): Promise<{ data: User[]}> => {
    try {
      const response = await usersAPI.getUsers(params);
      const data: User[] = response.data.data;
      users_result.value = data
      return { data };
    } catch (error) {
      console.error('Error fetching user s:', error);
      throw error;
    }
  };

  return {
    users,
    users_result,
    fetchUsers,
    fetchUserById,
    createUser,
    updateUser,
    deleteUser,
    searchUsers
  };
});
